import {styled} from '@linaria/react';
import React, {FC} from 'react';
import {COLORS} from '../../../constants/colors';
import {Text} from '../Text/Text';

interface ChipProps {
  className?: string;
  label: string;
}

export const Chip: FC<ChipProps> = ({className, label}) => {
  return (
    <Wrapper className={className}>
      <Text size="px10" weight="mediumHeavy" transform="uppercase">
        {label}
      </Text>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  padding: 4px 12px;
  align-items: center;
  border-radius: 50px;
  border: 1px solid ${COLORS['Outline.Grey']};
  background: ${COLORS['Fill.White']};
  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.08);
  justify-content: center;
  width: fit-content;
`;
